import React from 'react';
import { bool, object, string, node, array } from 'prop-types';
import classNames from 'classnames';
import GigCardCarousel from '@fiverr-private/gig_listings/src/entries/GigCardCarousel';
import GigCardCarouselHOC from '../GigCardCarouselHOC';
import { getSliderConfig } from './config';

import './style.scss';

const GigCardCarouselWrapper = ({
    boxTitle,
    boxClass,
    boxLocation = 'bottom',
    showTranslatedUGC = false,
    gigs = [],
    isLoading = true,
    contextEnrichment = {}
}) => {
    const boxClasses = classNames('gig-card-carousel-wrapper', boxClass);
    const { sliderBaseNum, sliderBreakpoints } = getSliderConfig(boxLocation);

    return (
        <div className={boxClasses}>
            <h2 className="section-title">{boxTitle}</h2>
            <GigCardCarousel gigs={gigs}
                sliderBaseNum={sliderBaseNum}
                sliderBreakpoints={sliderBreakpoints}
                isLoading={isLoading}
                showTranslatedUGC={showTranslatedUGC}
                lazyLoad={true}
                {...contextEnrichment}/>
        </div>
    );
};

GigCardCarouselWrapper.propTypes = {
    boxClass: string,
    boxLocation: string,
    boxTitle: node,
    showTranslatedUGC: bool,
    gigs: array,
    isLoading: bool,
    contextEnrichment: object
};

export { GigCardCarouselWrapper };
export default GigCardCarouselHOC(GigCardCarouselWrapper);
